import { render } from "./Create.vue?vue&type=template&id=33e04166"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DonationTypes/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33e04166"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33e04166', __exports__)) {
    console.log('reload')
    api.reload('33e04166', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=33e04166", () => {
    console.log('re-render')
    api.rerender('33e04166', render)
  })

}


export default __exports__